import styled from "styled-components";

export const TableContainer = styled.div`
  background: var(--bg-white);
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  border-radius: 10px;
  margin: 0 auto;
  padding: 12px 24px;
  margin: 16px 0;
  color: #27548c;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 242px;
  width: unset !important;
  position: relative;

  .cancel-button-modal {
    width: 80px;
    height: 30px;
    border-radius: 5px;
    border: 1px solid #727577;
    margin: 0 2px;
    background-color: #9ea0a2;
    color: #000000;
    cursor: pointer;
    transition: 0.2s all;
  }

  .cancel-button-modal:hover {
    background-color: #75757a;
  }

  .accept-button-modal {
    width: 80px;
    height: 30px;
    border-radius: 5px;
    border: 1px solid #109565;
    margin: 0 2px;
    background-color: #41b68c;
    color: #f0f7ff;
    cursor: pointer;
    transition: 0.2s all;
  }

  .accept-button-modal:hover {
    background-color: #109565;
  }

  &.disable {
    & > div:last-child:hover {
      text-decoration: none;
    }
    &:hover {
      cursor: not-allowed;
    }
  }
  div {
    width: unset !important;
  }
  & > div:nth-of-type(1) {
    & > div:nth-of-type(1) {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
  & > div:nth-of-type(2),
  div:nth-of-type(3) {
    border-bottom: 1px solid var(--bg-disable);
    padding-bottom: 7px;
  }
  & > div:nth-of-type(4) {
    color: var(--text-500);
    font-weight: 800;
    & > div:nth-of-type(2) {
    }
  }
  & > div:nth-of-type(3) {
    & > div:nth-of-type(2) {
    }
  }
`;

export const TableRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & .rowTitle {
    font-size: 14px;
    font-weight: 700;
    color: var(--text-400);
  }
  & .textCount {
    color: var(--text-200);
    font-weight: 400;
    font-size: 12px;
  }
  &.time > div,
  &.status > div {
    color: var(--text-400);
    font-size: 12px;
    font-weight: 400;
  }
  &.cost > div {
    font-size: 12px;
    font-weight: 800;
    color: var(--text-500);
  }
  & button {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 0;
    background: transparent;
    outline: none;
    border-radius: 8px;
    border: 2px solid var(--primary-500);
    cursor: pointer;
    color: var(--primary-500);
    font-weight: 800;
    font-size: 14px;
  }
`;

export const Paginate = styled.nav`
  display: flex;
  direction: rtl;
  align-items: center;
  justify-content: center;
  ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: max-content;
    li {
      display: inline-block;
      margin: 0 4px;
      a {
        color: #27548c;
        width: 100%;
        width: 30px;
        height: 30px;
        font-size: 16px;
        font-weight: 400;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }
      a.active {
        background-color: #d1e6ff;
        border-radius: 8px;
      }
    }
  }
`;
